<div class="modal-header">
  <h5 class="modal-title mt-0">Add Contact</h5>
  <button type="button" class="btn-close" aria-hidden="true"
    (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <form [formGroup]="formData" (ngSubmit)="onSubmit()">
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label">Contact Type</label>
        <select class="form-select" formControlName="contactType"
          [ngClass]="{'is-invalid': submitted && formData.get('contactType')?.errors}">
          <option *ngFor="let type of contactTypeList" [ngValue]="type.id">{{type.label}}</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label">Contact Number</label>
        <input type="text" class="form-control" formControlName="contactNumber"
          [ngClass]="{'is-invalid': submitted && formData.get('contactNumber')?.errors}">
        <div *ngIf="submitted && formData.get('contactNumber')?.errors" class="invalid-feedback">
          <span *ngIf="formData.get('contactNumber')?.errors?.required">Contact number is required.</span>
          <span *ngIf="formData.get('contactNumber')?.errors?.pattern">Contact number must be 10 digits.</span>
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label">First Name</label>
        <input type="text" class="form-control" formControlName="firstName">
      </div>
      <div class="col-md-6">
        <label class="form-label">Last Name</label>
        <input type="text" class="form-control" formControlName="lastName">
      </div>
      <div class="col-md-6">
        <label class="form-label">Email</label>
        <input type="email" class="form-control" formControlName="emailId"
          [ngClass]="{'is-invalid': submitted && formData.get('emailId')?.errors}">
        <div *ngIf="submitted && formData.get('emailId')?.errors" class="invalid-feedback">
          <span *ngIf="formData.get('emailId')?.errors?.pattern">Email format is invalid.</span>
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label">Aadhar No</label>
        <input type="text" class="form-control" formControlName="aadharNo"
          [ngClass]="{'is-invalid': submitted && formData.get('aadharNo')?.errors}">
        <div *ngIf="submitted && formData.get('aadharNo')?.errors" class="invalid-feedback">
          <span *ngIf="formData.get('aadharNo')?.errors?.pattern">Aadhar no must be 12 digits.</span>
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label">PAN Card No</label>
        <input type="text" class="form-control" formControlName="panCardNo"
          [ngClass]="{'is-invalid': submitted && formData.get('panCardNo')?.errors}">
        <div *ngIf="submitted && formData.get('panCardNo')?.errors" class="invalid-feedback">
          <span *ngIf="formData.get('panCardNo')?.errors?.pattern">PAN card no format is invalid.</span>
        </div>
      </div>
    </div>

    <div class="modal-footer px-0 pb-0 mt-3">
      <button type="button" class="btn btn-outline-secondary"
        (click)="activeModal.dismiss('cancel')">Cancel</button>
      <button type="submit" class="btn btn-success" [disabled]="isSaving || !customerDetail">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        Save
      </button>
    </div>
  </form>
</div>
